module.exports = __webpack_public_path__ + "img/gray_loading.ee72205f.gif";